// ===========================================
// AlertsBanner — Bandeau d'alertes critiques
// Ne s'affiche que si des alertes existent (sinon return null).
// ===========================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleFilled, WarningFilled } from '@ant-design/icons';

const SEVERITY_ICONS = {
    critical: <ExclamationCircleFilled />,
    warning:  <WarningFilled />,
};

const AlertsBanner = ({ alertes }) => {
    const navigate = useNavigate();

    if (!alertes || alertes.length === 0) return null;

    // Détermine la "tonalité" du bandeau : critical prime sur warning
    const hasCritical = alertes.some((a) => a.severity === 'critical');
    const toneClass = hasCritical ? 'alerts-banner-critical' : 'alerts-banner-warning';

    return (
        <div className={`alerts-banner ${toneClass}`} role="alert">
            <div className="alerts-banner-icon">
                {SEVERITY_ICONS[hasCritical ? 'critical' : 'warning']}
            </div>
            <div className="alerts-banner-content">
                <div className="alerts-banner-title">Actions urgentes</div>
                <ul className="alerts-banner-list">
                    {alertes.map((a) => (
                        <li key={a.type} className="alerts-banner-item">
                            <span className={`alerts-banner-dot alerts-banner-dot-${a.severity}`} />
                            <span className="alerts-banner-message">{a.message}</span>
                            {a.actionUrl && (
                                <button
                                    type="button"
                                    className="alerts-banner-action"
                                    onClick={() => navigate(a.actionUrl)}
                                >
                                    {a.actionLabel || 'Voir'}
                                </button>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default AlertsBanner;
